import React, { useState } from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Menu, useTheme } from '@mui/material';
import { filter } from '../..';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';

export interface IFilterBySelectReturn {
  orderByColumn: string;
  orderByIndex: number;
}

export interface IFilterBySelect {
  variant?: 'contained' | 'outlined' | 'text';
  onChange?: (data: IFilterBySelectReturn, event: React.MouseEvent<HTMLLIElement, MouseEvent>) => any;
  selectedValue?: string;
  hideDelete?: boolean;
  passedInOptions?: filter[];
}

const FilterBySelect = ({
  passedInOptions,
  variant,
  onChange,
  selectedValue = '0',
  hideDelete = false
}: IFilterBySelect) => {
  const options: any[] = [];

  passedInOptions?.forEach(option => {
    if (!option.name.toLocaleLowerCase().includes('delete') || !hideDelete) {
      options.push(option.name);
    }
  });

  const [selectedIndex, setSelectedIndex] = useState(() => {
    const parsedIndex = Number(selectedValue);

    return Number.isNaN(parsedIndex) ? 0 : parsedIndex;
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const theme = useTheme();
  const open = Boolean(anchorEl);
  const { t } = useVigoTranslation();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
    let returnColumn = '';

    passedInOptions?.forEach(option => {
      if (option.name === options[index]) {
        returnColumn = option.property;
      }
    });

    const returnData: IFilterBySelectReturn = {
      orderByColumn: returnColumn,
      orderByIndex: index
    };

    if (onChange) {
      onChange(returnData, event);
    }

    setSelectedIndex(index);
    handleClose();
  };

  return (
    <>
      <Button
        id="FilterBySelectOptions-button"
        aria-controls={open ? 'FilterBySelectOptions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          alignSelf: 'flex-end',
          color: theme.palette.mode === 'light' ? theme.palette.customColors.main : '#fff',
          textTransform: 'capitalize'
        }}
        variant={variant}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}>
        {options ? t(options[selectedIndex]) : []}
      </Button>
      <Menu
        id="FilterBySelectOptions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'FilterBySelectOptions-button'
        }}>
        {options?.map((option, index) => (
          <MenuItem
            sx={{ alignSelf: 'flex-end', textTransform: 'capitalize' }}
            key={option?.toLocaleString()}
            selected={index === selectedIndex}
            onClick={event => handleMenuItemClick(event, index)}>
            {t(option)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterBySelect;
